import { UserWorkoutSession } from 'fitbeat.gym-core';
import { Linking, NativeModules, Platform } from 'react-native';
import BaseNonRealTimeConnectedApp from '../base-non-real-time-connected-app';
import {
  AuthorizationStatus, IAuthorizationResult, INotOnboardable, IOnboardable,
} from '../connected-workout-app';
import { createUserServiceClient } from '../../utils/apiClientFactory';
import { Logger } from '../../utils/Logger';

class GarminConnect extends BaseNonRealTimeConnectedApp {
  public async isOnboardable(): Promise<IOnboardable | INotOnboardable> {
    try {
      const isAppInstalled = await this.isAppInstalled();

      if (!isAppInstalled) {
        return {
          isOnboardable: false,
        };
      }

      return {
        isOnboardable: true,
        isAppInstalled,
      };
    } catch (err) {
      Logger.notify(err);
      return {
        isOnboardable: false,
      };
    }
  }

  public isAvailable(): Promise<boolean> {
    return Promise.resolve(true);
  }

  public authorizationStatus(): Promise<AuthorizationStatus> {
    return Promise.resolve(AuthorizationStatus.notDetermined);
    // This is worked out in the app state as it requires a user
  }

  public stopAndSaveWorkout(workoutSession: UserWorkoutSession): Promise<void> {
    Logger.leaveBreadcrumb('Garmin Connect stopAndSaveWorkout is not implemented');
    return Promise.resolve();
  }

  public async requestAuthorization(): Promise<IAuthorizationResult> {
    const userServiceClient = createUserServiceClient();
    try {
      const { usersAuthenicationLink } = await userServiceClient.authorizeGarminConnect();
      return {
        success: true,
        urlRedirect: usersAuthenicationLink,
      };
    } catch (err) {
      return {
        success: false,
        errorDisplayMessage: (err as Error).message,
      };
    }
  }

  private async isAppInstalled(): Promise<boolean> {
    if (Platform.OS === 'ios') {
      return Linking.canOpenURL('connect://app');
    }
    const { PackageInfo } = NativeModules;
    if (!PackageInfo) {
      Logger.notify(new Error('PackageInfo native module not found'));
      return false;
    }
    return PackageInfo.isAppInstalled('com.garmin.android.apps.connectmobile');
  }
}

export default new GarminConnect('Garmin Connect');
